export default __webpack_public_path__ + "static/media/hdfcBank.f177b9df.png";